<script>
import options from './StafetHeader.options'
export default options
</script>

<template>
  <article class="kb-stafet-flow-title">
    <ul class="kb-stafet-flow-title__step-indicator" v-if="steps.length > 0">
      <template v-for="(step, index) in steps" :key="index">
        <li class="kb-stafet-flow-title__step-indicator-list-item" >
          <div role="img" :aria-label="`${step.active ? 'Nuværende ' : ''}Trin: ${step.number}`" class="kb-stafet-flow-title__step-indicator-circle" :class="step.active ? 'kb-stafet-flow-title__step-indicator-circle--active-step' : ''">
            <p>{{ step.number }}</p>
          </div>
          <strong>{{ step.title }}</strong>
        </li>
      </template>      
    </ul>

    <h1 class="kb-stafet-flow-title__title">{{ title }}</h1>
    
    <div class="kb-stafet-flow-title__breaker">
      <svg viewBox="0 0 81 11" fill="none" xmlns="http://www.w3.org/2000/svg" ><path d="M2 .5h79v1H2v-1ZM1.5 2v9h-1V2h1Zm.5-.5a.5.5 0 0 0-.5.5h-1A1.5 1.5 0 0 1 2 .5v1Z" /></svg>
    </div>

    <div class="kb-stafet-flow-title__description">
      <p class="kb-stafet-flow-title__description-text">{{ description }}</p>
    </div>

  </article>
</template>
